<dbw-investor-viewer-accordion
  anchorId="investor-viewer-actifs"
  accordionTitle="Actifs"
  [itemsCount]="assets().length">
  @if (assets().length === 0) {
    <div class="empty-state">Aucun actif disponible.</div>
  } @else {
    <div class="section-stack">
      @for (asset of assets(); track asset.assetId) {
        <article class="sub-card dbw-card dbw-card--md">
          <header class="entity-header">
            <div>
              <h5>{{ formatText(asset.designation) }}</h5>
              <p>
                Actif #{{ asset.assetId }} • Nature
                {{ formatText(asset.natureCode) }} • ArianeId
                {{ formatText(asset.arianeId) }}
              </p>
            </div>
            <strong class="entity-value">{{
              formatCurrency(asset.estimatedValue)
            }}</strong>
          </header>

          <div class="detail-grid">
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Date d'acquisition</span>
              <strong>{{ formatDate(asset.acquisitionDate) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Naissance usufruitier</span>
              <strong>{{ formatDate(asset.usufructBirthDate) }}</strong>
            </article>
          </div>

          @if (asset.notes?.trim()) {
            <div class="note-banner dbw-card dbw-card--md">
              <span class="identity-item__label">Note</span>
              <strong>{{ asset.notes }}</strong>
            </div>
          }

          <div class="mini-block">
            <div class="subheading subheading--small"><h5>Détenteurs</h5></div>
            @if (asset.holders.length === 0) {
              <div class="empty-inline">Aucun détenteur.</div>
            } @else {
              <div class="mini-card-list">
                @for (holder of asset.holders; track $index) {
                  <article class="mini-card dbw-card dbw-card--lg">
                    <strong>{{ formatHolderLabel(holder.investorId) }}</strong>
                    <span>{{ formatAssetHolderShares(holder) }}</span>
                  </article>
                }
              </div>
            }
          </div>

          @if (getLinkedLiabilities(asset.assetId).length > 0) {
            <div class="mini-block">
              <div class="subheading subheading--small"><h5>Passifs liés</h5></div>
              <div class="mini-card-list">
                @for (
                  liability of getLinkedLiabilities(asset.assetId);
                  track liability.liabilityId
                ) {
                  <article class="mini-card dbw-card dbw-card--lg">
                    <strong>{{ formatLiabilityLabel(liability) }}</strong>
                    <span>
                      Passif #{{ liability.liabilityId }} • ArianeId
                      {{ formatText(liability.arianeId) }}
                    </span>
                  </article>
                }
              </div>
            </div>
          }

          @if (parseAdditionalFields(asset.additionalFieldsJson).length > 0) {
            <div class="mini-block">
              <div class="subheading subheading--small">
                <h5>Champs complémentaires</h5>
              </div>
              <div class="mini-card-list">
                @for (
                  field of parseAdditionalFields(asset.additionalFieldsJson);
                  track $index
                ) {
                  <article class="mini-card dbw-card dbw-card--lg">
                    <span class="detail-item__label">{{ field.label }}</span>
                    <strong>{{ field.value }}</strong>
                  </article>
                }
              </div>
            </div>
          }
        </article>
      }
    </div>
  }
</dbw-investor-viewer-accordion>
